if (!customElements.get('pdp-swiper-slider')) {
  class PDPSwiperSlider extends HTMLElement {
    constructor() {
      super();
      this.swiperContainer = this.querySelector('.swiper');
      this.swiperHTML = this.swiperContainer.querySelector('.swiper .swiper-wrapper');
      this.thumbnailContainer = this.querySelector('.swiper-thumbs');
      this.closeFullScreen = this.querySelector('#close-full-screen');
    }

    connectedCallback() {
      this.swiperInit();
      this.fullscreenHandler();
      this.updateOnVariantChange();
    }

    swiperInit() {
      this.thumbnail = new Swiper(this.thumbnailContainer, {
        spaceBetween: 8,
        slidesPerView: 'auto',
        freeMode: true,
        watchSlidesProgress: true,
        slideClass: 'swiper-thumb',
        observer: true,
      });
      this.swiper = new Swiper(this.swiperContainer, {
        slidesPerView: 1,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true,
        },
        keyboard: {
          enabled: true,
        },
        thumbs: {
          swiper: this.thumbnail,
        },
        observer: true,
      });
    }

    fullscreenHandler() {
      const openFullScreen = this.querySelector('#full-screen');
      if (!openFullScreen || !this.closeFullScreen) return;
      openFullScreen.addEventListener('click', () => {
        this.addEventListener('fullscreenchange', (event) => {
          if (!document.fullscreenElement) this.classList.remove('full-screen');
        });

        if (!document.fullscreenElement) {
          this.requestFullscreen({ navigationUI: 'hide' })
            .then(() => this.classList.add('full-screen'))
            .catch((err) => {
              alert(`Error attempting to enable fullscreen mode: ${err.message} (${err.name})`);
            });
        } else {
          document
            .exitFullscreen()
            .then(() => this.classList.remove('full-screen'))
            .catch((err) => console.error(err));
        }
      });
      this.closeFullScreen.addEventListener('click', () => {
        document
          .exitFullscreen()
          .then(() => this.classList.remove('full-screen'))
          .catch((err) => console.error(err));
      });
    }

    updateOnVariantChange() {
      document.body.addEventListener('beforeVariantChange', () => {
        this.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');
      });
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const newHTML = event.data.html;
        const newSliderContent = newHTML.querySelector('pdp-swiper-slider .swiper .swiper-wrapper');
        if (newSliderContent.querySelector('.swiper-slide') && newSliderContent !== this.swiperHTML) {
          const newSliderThumb = newHTML.querySelector('pdp-swiper-slider .swiper-thumbs .swiper-wrapper');
          this.swiperContainer.querySelector('.swiper-wrapper').innerHTML = newSliderContent.innerHTML;
          this.thumbnailContainer.querySelector('.swiper-wrapper').innerHTML = newSliderThumb.innerHTML;
          this.fullscreenHandler();
        }
        this.classList.remove('loading');
        this.querySelector('.loading__spinner').classList.add('hidden');
      });
    }
  }
  customElements.define('pdp-swiper-slider', PDPSwiperSlider);
}
